import React from "react";

const ColorPaletteItem = ({ background, linkBackground, textColor }) => {
  return (
    <svg
      width="38"
      height="38"
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1"
        y="1"
        width="36"
        height="36"
        rx="2"
        fill={background}
        stroke="#DDE0E4"
      />
      <rect x="7" y="7" width="24" height="24" rx="12" fill={linkBackground} />
      <path
        d="M18.1738 24.0215V15.6953H15.2002V14H23.1641V15.6953H20.1973V24.0215H18.1738Z"
        fill={textColor}
      />
    </svg>
  );
};

export default ColorPaletteItem;
